import styled from 'styled-components';

const ShareHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const ShareHeaderLeft = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const ShareHeaderText = styled.div`
  align-items: center;
  display: flex;
  gap: 0.4rem;
  justify-content: space-between;
`;

export { ShareHeader, ShareHeaderLeft, ShareHeaderText };
